export const SOCIAL_FEED_TITLE = "PriceMe Social | The homes everyone’s talking about";
